<template>
  <el-tabs v-model="activeName" class="tabs">
    <el-tab-pane name="first" label="电脑端" class="mineCon">
      <div class="help">
        <p><strong>第一步：</strong>登录状态下，点击顶部菜单栏中的<span class="orange">【专业医生】</span>或<span class="orange">【我要咨询】</span>
        </p>
        <img src="../../../assets/img/userAppoint_a.png" alt="">
        <p><strong>第二步：</strong>① 在【专业医生】页面，点击可预约医生的<span class="orange">【主页】</span>按钮，在【医生主页】中点击<span class="orange">【我要咨询】</span>按钮，进入预约页面
        </p>
        <img src="../../../assets/img/userAppoint_b.png" alt="" width="900">
        <p>② 在【我要咨询】页面，点击<span class="orange">【预约】</span>按钮，进入预约页面</p>
        <img src="../../../assets/img/userAppoint_c.png" alt="" width="900">
        <p><strong>第三步：</strong>① 在【预约】页面，先在【可预约时间表】中选择预约时间，按照提示填写预约信息<br/>
          ② 仔细阅读<span class="orange">【《心理亦笙》咨询预约协议】</span>，如您没有异议请勾选：√我已阅读并同意<br/>
          ③ 点击<span class="orange">【提交预约】</span>按钮，进入【支付页面】<br/>
        </p>
        <img src="../../../assets/img/userAppoint_d.png" alt="">
        <p><strong>第四步：</strong>在【支付页面】，确认预约信息，选择支付方式，目前仅支持【微信支付】，点击<span class="orange">【立即支付】</span>按钮，显示出【微信二维码】，
          请使用微信扫一扫功能进行支付，支付完成，即预约完成
        </p>
        <img src="../../../assets/img/userAppoint_e.png" alt="" width="911">

      </div>
    </el-tab-pane>
    <el-tab-pane name="second" label="移动端" class="mineCon">
      <div class="help">
        <div class="flex userPh">
          <p><strong>第一步：</strong>登录状态下，在【首页】，点击<span class="orange">【我要咨询】</span>按钮，进入【医生列表页面】</p>
          <p><strong>第二步：</strong>在【医生列表】中，点击要进行咨询预约的医生条目，进入【医生主页】</p>
          <p><strong>第三步：</strong>在【医生主页】，选择预约时间，并点击<span class="orange">【我要预约】</span>按钮</p>
        </div>
        <img src="../../../assets/img/userAppointRes_a.png" alt="">
        <div class="flex userPh">
          <p><strong>第四步：</strong>按照提示填写相关信息，点击<span class="orange">【提交预约】</span>按钮</p>
          <p><strong>第五步：</strong>在支付页面选择【微信支付】，点击<span class="orange">【我要支付】</span>按钮</p>
          <p><strong>第六步：</strong>在微信中点击<span class="orange">【确认支付】</span>，完成预约</p>
        </div>
        <img src="../../../assets/img/userAppointRes_b.png" alt="">
        <p class="orange">【注】当完成支付时，优惠金额大于等于支付金额时，点击【提交预约】，即可完成预约 </p>
      </div>
    </el-tab-pane>
  </el-tabs>


</template>

<script>
export default {
  name: "appointHelp",
  data() {
    return {activeName: 'first'}
  },
  mounted() {
  },
  methods: {},
}
</script>

<style lang="scss" scoped>
@import "../../../assets/css/help";
</style>
